module.exports = __webpack_public_path__ + "static/thumbnail-legaleye-565a35913034c80e52858b5dbe0879d3.png";